import { getQldRegionGeo, getEduData } from '../api';

// Internal function
const fetchEduData = () => {
  return dispatch => {
    // Fetch data from script-generated JSON files
    return getEduData()
      .then(response => {
        dispatch({ type: 'EDU_DATA:SUCCESS', payload: response });
      })
      .catch(err => {
        dispatch({ type: 'EDU_DATA:ERROR', payload: err });
      });
  };
};


// Internal function
const fetchQldRegionGeo = () => {
  return dispatch => {
    dispatch({ type: 'REGIONS_QLD_GEO:REQUEST' });
    return getQldRegionGeo()
      .then(response => {
        dispatch({ type: 'REGIONS_QLD_GEO:SUCCESS', payload: response });
      })
      .catch(err => {
        dispatch({ type: 'REGIONS_QLD_GEO:ERROR', payload: err });
      });
  };
};


export const fetchRegions = () => {
  return dispatch => {
    dispatch({ type: 'REGIONS_ALL:REQUEST' });
    return Promise.all([
      dispatch(fetchQldRegionGeo()),
      dispatch(fetchEduData())
    ])
      .then(() => {
        dispatch({ type: 'REGIONS_ALL:SUCCESS' });
      })
      .catch(err => {
        dispatch({ type: 'REGIONS_ALL:ERROR', payload: err });
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/regions.js